<div class="edit-page-root-container shop-payroll-settings-edit-root-container">
    <div class="page-content">
        <div class="page-header">
            <button mat-button class="nav-button" (click)="navBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <div class="title">
                {{title}}
            </div>
            <div class="action-btn-container">
                @if(permission.can_edit){
                <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
                <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
                }
            </div>
        </div>
        <div class="page-details">
            <form class="edit-form" [formGroup]="editForm">
                <div class="detail-section">
                    <div class="content-container">
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="code">
                                    <mat-label>Code</mat-label>
                                    <input matInput formControlName="code" maxlength="10" readonly>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('required')">Code should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                                        10.</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="input-box-right">
                                <mat-form-field class="name">
                                    <mat-label>Name</mat-label>
                                    <input matInput formControlName="name" maxlength="50" readonly>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('required')">Name should be
                                        entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                                        50.</mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="input-group">
                            <div class="input-box-left">
                                <mat-form-field class="group-code">
                                    <mat-label>Group Code</mat-label>
                                    <input matInput formControlName="group_code" [matAutocomplete]="auto">
                                    <button mat-icon-button matSuffix (click)="clearGroup()"
                                        *ngIf="editForm.get('group_code')?.value">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <mat-autocomplete #auto="matAutocomplete"
                                        (optionSelected)="onGroupSelected($event)">
                                        <mat-option *ngFor="let group of filteredGroups | async" [value]="group.code">
                                            {{group.code}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="editForm.controls['group_code'].hasError('required')">Group Code
                                        should be entered</mat-error>
                                    <mat-error *ngIf="editForm.controls['group_code'].hasError('maxlength')">Maximum
                                        length is 10.</mat-error>
                                </mat-form-field>
                            </div>
                            <div class="input-box-right">
                                <mat-form-field class="group-name" style="width: 100%;">
                                    <mat-label>Group Name</mat-label>
                                    <input matInput [value]="selectedGroupName" readonly>
                                </mat-form-field>



                            </div>
                            <mat-form-field class="cost-code">
                                <mat-label>Cost Code</mat-label>
                                <input matInput formControlName="cost_code" maxlength="10">
                                <mat-error *ngIf="editForm.controls['cost_code'].hasError('required')">Cost Code should
                                    be entered</mat-error>
                                <mat-error *ngIf="editForm.controls['cost_code'].hasError('maxlength')">Maximum length
                                    is 10.</mat-error>
                            </mat-form-field>

                        </div>

                    </div>
                </div>
            </form>
        </div>
    </div>
</div>